@let hasShiftDeletePermission =
  can(RoleAction.Delete, RolePermissionSubject.Shift);
@let hasServiceUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Service);
@let hasDeletePermission =
  hasServiceActivity
    ? hasShiftDeletePermission && hasServiceUpdatePermission
    : hasShiftDeletePermission;

@if (
  {
    shiftsStatusCheck: (selectedShifts | canAllShiftBeModified),
    hasCompanyAdminRole: hasCompanyAdminRole$ | async,
  };
  as data
) {
  <button
    nz-button
    nzType="default"
    class="w-100 fw-normal"
    (click)="deleteShifts()"
    [disabled]="
      !hasDeletePermission ||
      (!data.shiftsStatusCheck && !data.hasCompanyAdminRole) ||
      isOperationOnGoing
    "
    nz-tooltip
    [nzTooltipTitle]="
      !hasDeletePermission ? ('general.forbidden_action' | translate) : ''
    "
  >
    {{
      'page.shift_timeline.drawer.shifts_form.delete_multi_shift' | translate
    }}
  </button>
}
